import { clearTeacherPortalView } from './teacherPortalView';

/** localStorage keys for class/course/semester selection (kept on school switch). */
export const IDENTITY_SELECTION_LS_KEYS = [
  'CurrentClassId',
  'CurrentCourseId',
  'CurrentSemesterId',
] as const;

/** User preference keys cleared on logout (includes school/class/course/semester). */
export const USER_PREFERENCE_LS_KEYS = [
  'CurrentSchoolId',
  ...IDENTITY_SELECTION_LS_KEYS,
  'CurrentGroupId',
  'teach-evaluation-page--expanded',
  'ci',
  'casdoorAuthCode',
  'casdoorAuthState',
] as const;

export const AUTH_LS_KEYS = [
  'casdoorToken',
  'casdoorRefreshToken',
  'casdoorUser',
  '_authing_token',
] as const;

/** Remove class/course/semester selection so a school switch cannot reuse stale IDs. */
export function clearIdentitySelectionStorage(): void {
  for (const key of IDENTITY_SELECTION_LS_KEYS) {
    localStorage.removeItem(key);
  }
}

function clearLegacyAuthingKeys(): void {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith('_authing')) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}

/** Clear auth tokens and all user session preferences on logout. */
export function clearLogoutStorage(): void {
  for (const key of AUTH_LS_KEYS) {
    localStorage.removeItem(key);
  }
  for (const key of USER_PREFERENCE_LS_KEYS) {
    localStorage.removeItem(key);
  }
  clearLegacyAuthingKeys();
  clearTeacherPortalView();
}
